module.exports = __webpack_public_path__ + "img/22.270f5119.jpg";